var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-sm",class:'fa-' + _vm.icon}),_c('span',{staticClass:"text-sm"},[_vm._v(" "+_vm._s(_vm.custom_caption)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }